import ability from './ability'
import router from "@/router";

export const canNavigate = to => to.matched.some(route => {
    if (localStorage.getItem('token')){
        if (JSON.parse(localStorage.getItem('user')).isSuperUser) {
            return true
        } else if (Array.isArray(route.meta.action)) {
            return route.meta.resource.some((resource, index) => {
                return ability.can(route.meta.action[index] || 'read', resource);
            })
        } else {
            if (route.meta.action) {
                return ability.can(route.meta.action || 'read', route.meta.resource)
            }else{
                return true
            }

        }
    }else{
        router.push({name:'login'})
    }
})

export const _ = undefined
